export const getEventCustom = /* GraphQL */ `query GetEventCustom($id: ID!) {
  getEvent(id: $id) {
    id
    organizationGroup
    name
    description
    imageUrl
    bannerImageUrl
    startTime
    endTime
    isHidden
    circleEventId
    circle {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      isUserHasPendingRequest
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    attendee(filter: {_deleted: {ne: true}}) {
      items {
        id
        organizationGroup
        eventAttendeeId
        event {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          isUserHasPendingRequest
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        eventAttendeeUserId
        status
        requestStatus
        user {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviter {
          id
          cognitoID
          email
          organizationGroup
          firstName
          lastName
          username
          avatarUrl
          bannerImageUrl
          bio
          jobTitle
          type
          lookingForType
          isClosedForAcceptingMentee
          joinedAt
          lastLoginAt
          deletedAt
          deletedBy
          phone
          points
          lifetimePoints
          dateOfBirth
          isOnboarded
          disabledQuickQuestion
          finishedUserGuideContext
          minimumIntroducers
          averageRating
          avgMentorRating
          avgMenteeRating
          avgAllyRating
          userHomepageConfig
          interest
          expertises
          awards
          titleRank
          sensitiveQuestionConsent
          isAskedTwiceAlready
          ethnicity
          sexuality
          extrovertOrIntrovert
          sensingOrIntuition
          thinkingOrFeeling
          judgingOrPerceiving
          personalityType
          religion
          class
          relationshipStatus
          childhoodZip
          dogOwner
          catOwner
          moonSign
          sunSign
          morningVsNightPerson
          hasSiblings
          birthOrder
          heroes
          sages
          celebsLoveToMeet
          personalityTest
          eatOutVsEatIn
          almaMater
          gender
          race
          vegan
          taxBracket
          nativeBorn
          currentZip
          artist
          musicalInstrument
          generation
          companyClub
          totalSiblings
          vegetarian
          birthCountry
          birthCity
          introVsExtro
          selectedFavorites
          zipCode
          collegeMajor
          isFirstGenerationCollege
          highSchool
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          userFocusedSkillTrackId
          userDepartmentId
          __typename
        }
        inviterNotes
        isInviterHR
        requestNotes
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        eventAttendeeInviterId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    interests
    privacy
    admins
    timezone
    location
    createdAt
    isManagedByHR
    owner
    isUserHasPendingRequest
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}`